(() => {
  if (window.nxoCartEventsBooted) return;
  window.nxoCartEventsBooted = true;
  const isAddRequest = (input, method) => {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      return url.origin === window.location.origin && /\/cart\/add(?:\.(?:js|json))?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  const confirm = (data) => {
    if (!data || data.status || data.errors) return;
    const items = Array.isArray(data.items) ? data.items : [data];
    if (!items.some(item => item && typeof item.key === 'string' && Number(item.quantity) > 0 && Number(item.variant_id || item.id) > 0)) return;
    document.dispatchEvent(new CustomEvent('nexo:cart-added', { detail: { confirmed: true } }));
  };
  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (...args) {
      const request = originalFetch.apply(this, args);
      if (isAddRequest(args[0], args[1]?.method || args[0]?.method)) {
        request.then(response => {
          if (!response.ok) return;
          try { response.clone().json().then(confirm).catch(() => {}); } catch {}
        }, () => {});
      }
      return request;
    };
  }
  const prototype = window.XMLHttpRequest?.prototype;
  if (!prototype) return;
  const requests = new WeakMap();
  const originalOpen = prototype.open;
  const originalSend = prototype.send;
  prototype.open = function (...args) {
    requests.set(this, isAddRequest(args[1], args[0]));
    return originalOpen.apply(this, args);
  };
  prototype.send = function (...args) {
    if (requests.get(this)) {
      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) return;
        try {
          if (this.responseType === 'json') confirm(this.response);
          else if (!this.responseType || this.responseType === 'text') confirm(JSON.parse(this.responseText));
        } catch {}
      }, { once: true });
    }
    return originalSend.apply(this, args);
  };
})();
